<template>
  <section class="platforms">
    <Container>
      <Title tag="h2">Plataformas y proyectos</Title>
      <Row>
<!--         <ColumnUi md="6" lg="4" class="platform">
          <div class="icon-wrapper">
            <Icon svg="folder" class="platform__icon" />
          </div>
          <div class="platform__info">
            <h3 class="platform__title">
              Infraestructura de Datos Espaciales IDE-IGP
            </h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/infraestructura-de-datos-espaciales/"
                target="_blank"
                theme="inverted"
                >Ir al servicio</Button
              ></span
            >
          </div>
        </ColumnUi> -->
        <ColumnUi md="6" lg="4" class="platform">
          <div class="icon-wrapper">
            <Icon svg="folder" class="platform__icon" />
          </div>
          <div class="platform__info">
            <h3 class="platform__title">
              Sistema de Alerta Sísmica Peruano - SASPe
            </h3>
            <span
              ><Button
                tag="a"
                href="https://www.igp.gob.pe/servicios/saspe/"
                target="_blank"
                theme="inverted"
                >Ir al servicio</Button
              ></span
            >
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
export default {
  components: {
    Container,
    Button,
    Icon,
    Row,
    ColumnUi,
    Title
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
@use "@/assets/styles/tools/_mixins.scss";
.title {
  color: variables.$text-inverted-color;
}
.platforms {
  padding: variables.$spacing-l 0;
  background: variables.$primary-color;
  color: variables.$text-inverted-color;
}
.platform {
  display: flex;
  align-items: center;
  grid-gap: 0 1.5em;
  margin-bottom: 2em;
  .icon-wrapper {
    min-width: 100px;
    height: 100px;
    background-color: variables.$background-header-color;
    border-radius: 50%;
    @include mixins.centered;
  }
  &__title {
    text-transform: uppercase;
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__icon {
    height: 3em;
    fill: variables.$primary-color;
    margin: 0;
  }
}
@media (min-width: variables.$lg) {
  .platform {
    margin-bottom: 0;
  }
}
</style>
